import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import selectedImg from './selected.svg';

const rules = ({ theme, selected }) => ({
  '&.settings-menu-item': { // fix console global css
    color: theme.color.light,
    cursor: 'pointer',
    position: 'relative',
    fontSize: theme.fontSize.normal,
    marginBottom: `${theme.margin.medium}`,
    opacity: theme.opacity.disabled,
    textTransform: 'capitalize',
    listStyleType: 'none',

    extend: {
      condition: selected,
      style: {
        color: theme.color.light,
        fontWeight: 'bold',
        opacity: theme.opacity.hovered,
        '::before': {
          content: `url(${selectedImg})`,
          position: 'absolute',
          zIndex: 1,
          extend: [
            {
              condition: theme.origDirection === 'ltr',
              style: {
                marginLeft: `-${theme.margin.large}`,
              },
            },
            {
              condition: theme.origDirection === 'rtl',
              style: {
                marginRight: `-${theme.margin.large}`,
              },
            },
          ],
        },
      },
    },
  },
});

const MenuItem = ({ selected, onClick, children }) => {
  const { css } = useFela({ selected });

  return (
    <div className={`${css(rules)} settings-menu-item`} onClick={onClick}>
      {children}
    </div>
  );
};

MenuItem.propTypes = {
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node,
};

export default React.memo(MenuItem);
